import { render, staticRenderFns } from "./UnsavedChanges.vue?vue&type=template&id=0bf2c270&scoped=true&"
import script from "./UnsavedChanges.vue?vue&type=script&lang=js&"
export * from "./UnsavedChanges.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedChanges.vue?vue&type=style&index=0&id=0bf2c270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf2c270",
  null
  
)

export default component.exports